import React from 'react';

import * as gridStyles from 'src/styles/card-grid-wrapper.module.scss';

const CardGridWrapper: React.FC = ({ children }) => {
    return <div className={gridStyles.grid}>{children}</div>;
};

export default CardGridWrapper;
